import React from "react";

export const SinaisIcon = ({
  size = "32",
  className,
}: {
  size?: string;
  className?: string;
}) => {
  return (
    <svg
      height={size}
      className={className}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 94.006 94.005"
    >
      <path
        d="M94.006,35.071c0,2.673-0.438,5.31-1.288,7.845c-3.993,18.067-38.521,39.923-39.99,40.853
		c-0.459,0.285-0.974,0.434-1.499,0.434c-0.524,0-1.046-0.132-1.505-0.434c-0.395-0.257-10.123-6.396-19.986-14.834
		c-1.181-1.018-1.305-2.774-0.314-3.95c1.015-1.166,2.769-1.308,3.952-0.317c7.352,6.281,14.782,11.359,17.867,13.405
		c10.37-6.761,33.263-23.962,36.069-36.648c0.733-2.241,1.064-4.279,1.064-6.348c0-7.202-3.921-13.841-10.235-17.319
		c-8.063-4.474-18.856-2.411-24.755,4.7c-1.06,1.284-3.24,1.284-4.32,0c-5.917-7.116-16.702-9.163-24.754-4.708
		c-6.334,3.486-10.255,10.121-10.255,17.316c0,2.055,0.348,4.102,0.996,6.079c0.416,1.85,1.212,3.659,2.225,5.536h16.356
		l5.617-12.909c0.481-1.105,1.63-1.8,2.812-1.676c1.204,0.105,2.208,0.971,2.476,2.147l4.135,17.482l5.349-8.771
		c0.504-0.833,1.411-1.342,2.391-1.342h10.151c1.545,0,2.801,1.251,2.801,2.803c0,1.544-1.256,2.802-2.801,2.802h-8.578
		l-8.058,13.236c-0.514,0.844-1.42,1.348-2.383,1.348c-0.153,0-0.301-0.012-0.438-0.033c-1.129-0.181-2.018-1.013-2.289-2.118
		L41.04,43.726l-2.986,6.873c-0.446,1.033-1.457,1.685-2.572,1.685H2.802C1.268,52.283,0,51.029,0,49.482
		c0-1.544,1.268-2.802,2.802-2.802h8.217c-0.583-1.391-1.054-2.741-1.346-4.047c-0.782-2.268-1.205-4.909-1.205-7.568
		c0-9.242,5.026-17.751,13.147-22.225c9.406-5.203,21.853-3.567,29.626,3.737c7.752-7.305,20.19-8.94,29.612-3.737
		C88.964,17.308,94.006,25.823,94.006,35.071z"
      />
    </svg>
  );
};
